import { useMutation } from "react-query";
import http from "infra/http";
import { EncomendaForm } from "../typings";
import { createFormData } from "infra/helpers/createFormData";

function useSaveEncomenda() {
  return useMutation(
    "/v1/encomenda",
    async (form: EncomendaForm) => {
      const formData = createFormData(form.files || [], form, "files");
      const { data } = await http.post(`/v1/encomenda`, formData);

      return data;
    },
    { retry: false }
  );
}

export default useSaveEncomenda;
